import { useCallback } from 'react'

import { QUERY_KEYS } from '~/constants/react-query'
import { REFETCH_FIAT } from '~/constants/refetch-intervals'
import { useRequiredActiveOrg } from '~/hooks/org'
import { useQueryWrapper } from '~/hooks/useQueryWrapper'
import { useServerRequests } from '~/hooks/useRequests'

type MicrodepositsResponse = {
  microdeposits: {
    microdepositId: string
    amount: string
    name: string
  }[]
}

export const useMicrodeposits = () => {
  const { serverGetRequest } = useServerRequests()
  const org = useRequiredActiveOrg()

  const fetchMicrodeposits = useCallback(async () => {
    const microdepositsResponse =
      (await serverGetRequest<MicrodepositsResponse>({
        path: `/api/org/bridge/microdeposits`,
        params: {
          orgId: org.id,
        },
      }))!

    return microdepositsResponse.data
  }, [org.id, serverGetRequest])

  const { data: responseData, isLoading } =
    useQueryWrapper<MicrodepositsResponse>({
      queryKey: [QUERY_KEYS.MICRODEPOSITS, org.id],
      queryFn: fetchMicrodeposits,
      refetchInterval: REFETCH_FIAT,
    })

  return {
    microdeposits: responseData?.microdeposits ?? [],
    isLoading,
  }
}
